import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { finalize } from 'rxjs';
import {
  TranslocoModule,
  TranslocoService,
  provideTranslocoScope,
} from '@ngneat/transloco';
import { languagePathBuilder } from '@features/auth/shared/languages';
import { ToastrService } from '@shared/components/lib-ngx/ngx-toastr/toastr/toastr.service';
import { AccountSettingService } from '@features/auth/core/domain/account/account-setting.service';
import { PHONE_NUMBER_PATTERN } from '@features/auth/shared/helpers/phone-number-pattern';
import { FORM_CONTROL_NUMBER_PATTERN } from '@features/auth/shared/helpers/only-number.pattern';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslocoModule],
  providers: [provideTranslocoScope('auth')],
  selector: 'app-input-phone-form',
  templateUrl: './input-phone-form.component.html',
})
export class InputPhoneFormComponent implements OnInit {
  @Input() spinner: boolean = false;
  @Output() nextStep = new EventEmitter<object>();
  @Output() previousStep = new EventEmitter();

  public service = inject(AccountSettingService);
  public formBuilder = inject(FormBuilder);
  public toast = inject(ToastrService);
  public language = inject(TranslocoService);

  public phoneForm!: FormGroup;

  // UI
  public LANUGAGE = languagePathBuilder([
    'component',
    'account',
    'changePhoneNumber',
    'formPhone',
  ]);
  public showWaitingWhenVerifyPhone: boolean = false;
  public displayErrorMessage = '';

  ngOnInit() {
    this.phoneForm = this.formBuilder.group({
      // DEFAULT CONTRY CODE = +84: vie
      countryCode: [
        '+84',
        Validators.compose([
          Validators.required,
        ]),
      ],
      phoneNumber: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(FORM_CONTROL_NUMBER_PATTERN)
        ]),
      ],
    });
  }

  get formControls() {
    return this.phoneForm.controls;
  }

  // input: 09828317823 > output: 9828317823
  // input: 9828317823 > output: 9828317823
  removeZeroPhoneNumber(phone: string): string {
    if (phone.startsWith('0')) {
      return phone.substring(1);
    }
    return phone;
  }

  onSubmit() {
    if (this.phoneForm.valid) {
      const { phoneNumber, countryCode } = this.phoneForm.getRawValue();
      const phone = countryCode + this.removeZeroPhoneNumber(phoneNumber);

      this.showWaitingWhenVerifyPhone = true;

      this.service
        .changePhoneNumber(phone)
        .pipe(finalize(() => (this.showWaitingWhenVerifyPhone = false)))
        .subscribe({
          next: (value) => {
            this.nextStep.emit({ phone });
          },
          error: (err) => {
            console.error(err);
            // TODO: RMove when chekc done
            // this.nextStep.emit({ phoneNumber });
            this.displayErrorMessage = err.message;
          },
        });
    } else {
      this.phoneForm.markAllAsTouched();
    }
  }

  showToast(translationKey: string, type: 'success' | 'error'): void {
    this.language.selectTranslate(this.LANUGAGE + translationKey).subscribe({
      next: (value) => {
        if (type === 'success') {
          this.toast.success(value);
        } else {
          this.toast.error(value);
        }
      },
    });
  }
}
